module.exports = __webpack_public_path__ + "img/20190830150129360截图20190830132511392.1aff9b14.jpg";